import {IconProps} from './types';

function EditIcon({fill = 'none', stroke = 'black'}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill={fill}>
            <path d="M15.9167 8.75H18.8333C19.0543 8.75 19.2663 8.8378 19.4226 8.99408C19.5789 9.15036 19.6667 9.36232 19.6667 9.58333V15.4167C19.6667 15.6377 19.5789 15.8496 19.4226 16.0059C19.2663 16.1622 19.0543 16.25 18.8333 16.25H1.33333C1.11232 16.25 0.900358 16.1622 0.744078 16.0059C0.587797 15.8496 0.5 15.6377 0.5 15.4167V9.58333C0.5 9.36232 0.587797 9.15036 0.744078 8.99408C0.900358 8.8378 1.11232 8.75 1.33333 8.75H5.91667" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.0509 10.7333L6.92676 12.4992L8.69426 8.37499L16.0601 1.00916L18.4168 3.36582L11.0509 10.7333Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16.886 4.89587L14.5293 2.54004" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.05 10.7333L8.69336 8.375" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default EditIcon;
